module.exports = __webpack_public_path__ + "assets/img/34_780_big.1699fd79.jpg";